import { ref } from 'vue'

const isUnauthorizedModalOpen = ref(false)

export const useAuthModal = () => {
    const showUnauthorizedModal = () => {
        isUnauthorizedModalOpen.value = true
    }

    const closeUnauthorizedModal = () => {
        isUnauthorizedModalOpen.value = false
    }

    return {
        isUnauthorizedModalOpen,
        showUnauthorizedModal,
        closeUnauthorizedModal
    }
}
